export class ArkikSpinnerOptions {
  delayTime: number;
  delayMessage?: string;
  errorTime: number;
  errorMessage?: string;
}
